export default "__VITE_ASSET__16b70103__"